import { Box } from '@ublend-npm/aulaui-core';
import React from 'react';

const AssignmentDetails = () => {
  return <Box>AssignmentDetails</Box>;
};

export default AssignmentDetails;
